import React from 'react';
import { Menu } from '@base-ui/react';

const APP_PREVIEW_ROLES = [
  { key: 'pma',      labelKey: 'library-preview-pma' },
  { key: 'retailer', labelKey: 'library-preview-retailer' },
  { key: 'hac',      labelKey: 'library-preview-client' },
  { key: 'admin',    labelKey: 'library-preview-admin' },
];

function LibraryRowActionsMenu({
  row,
  onDeployPre,
  onDeployPro,
  onDownload,
  onDelete,
  canPublishPre,
  canSeePublishPro,
  canPublishPro,
  canDeleteFile,
  onPreviewAs,
  t,
}) {
  const isExp = row.type?.toLowerCase() === 'exp';

  const actions = [
    ...(canPublishPre ? [{
      key: `pre-${row.id}`,
      label: t('library-action-deploy-pre'),
      disabled: row.status !== 'pending',
      onClick: () => onDeployPre(row.id),
    }] : []),
    ...(canSeePublishPro ? [{
      key: `pro-${row.id}`,
      label: t('library-action-deploy-pro'),
      disabled: !canPublishPro || row.status !== 'pre',
      onClick: () => onDeployPro(row),
    }] : []),
    ...(canDeleteFile && row.status === 'pending' ? [{
      key: `delete-${row.id}`,
      label: t('library-action-delete-file'),
      onClick: () => onDelete(row),
    }] : []),
    {
      key: `download-${row.id}`,
      label: t('library-action-download-file'),
      onClick: () => onDownload(row),
    },
  ];

  return (
    <Menu.Root>
      <Menu.Trigger
        className="library-view__menu-trigger"
        aria-label={t('library-action-open-menu', { fileName: row.fileName })}
      >
        ...
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Positioner align="end" positionMethod="fixed" style={{ zIndex: 2000 }}>
          <Menu.Popup className="library-menu__popup">

            {actions.map((action) => (
              <Menu.Item
                key={action.key}
                className="library-menu__item"
                disabled={action.disabled}
                onClick={action.onClick}
              >
                {action.label}
              </Menu.Item>
            ))}

            {row.status === 'pre' && (isExp ? (
              <Menu.Item className="library-menu__item" onClick={() => onPreviewAs(row, 'hac')}>
                {t('library-action-preview-pre')}
              </Menu.Item>
            ) : (
              <Menu.SubmenuRoot>
                <Menu.SubmenuTrigger className="library-menu__item library-menu__submenu-trigger">
                  {t('library-action-preview-pre')} ›
                </Menu.SubmenuTrigger>
                <Menu.Portal>
                  <Menu.Positioner positionMethod="fixed" style={{ zIndex: 2000 }}>
                    <Menu.Popup className="library-menu__popup">
                      {APP_PREVIEW_ROLES.map(({ key, labelKey }) => (
                        <Menu.Item
                          key={key}
                          className="library-menu__item"
                          onClick={() => onPreviewAs(row, key)}
                        >
                          {t(labelKey)}
                        </Menu.Item>
                      ))}
                    </Menu.Popup>
                  </Menu.Positioner>
                </Menu.Portal>
              </Menu.SubmenuRoot>
            ))}

          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  );
}

export default LibraryRowActionsMenu;
